import React, { useState, useMemo, useEffect } from "react";
import "./Wallet.css";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

const walletSummary = [
  { id: 1, user: "Arman", balance: 5000 },
  { id: 2, user: "Rahul", balance: 3200 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 3, user: "Amit", balance: 8700 },
  { id: 4, user: "Sana", balance: 1200 },
];

const transactions = [
  { id: 1, user: "Arman", amount: 500, type: "Credit", date: "2026-03-10" },
  { id: 2, user: "Rahul", amount: 200, type: "Debit", date: "2026-03-11" },
  { id: 3, user: "Amit", amount: 1000, type: "Credit", date: "2026-03-12" },
  { id: 4, user: "Sana", amount: 300, type: "Debit", date: "2026-03-13" },
  { id: 4, user: "Sana", amount: 300, type: "Debit", date: "2026-03-13" },
  { id: 4, user: "Sana", amount: 300, type: "Debit", date: "2026-03-13" },
  { id: 4, user: "Sana", amount: 300, type: "Debit", date: "2026-03-13" },
  { id: 4, user: "Sana", amount: 300, type: "Debit", date: "2026-03-13" },
  { id: 4, user: "Sana", amount: 300, type: "Debit", date: "2026-03-13" },
  { id: 4, user: "Sana", amount: 300, type: "Debit", date: "2026-03-13" },
  { id: 4, user: "Sana", amount: 300, type: "Debit", date: "2026-03-13" },
  { id: 4, user: "Sana", amount: 300, type: "Debit", date: "2026-03-13" },
  { id: 5, user: "Arman", amount: 700, type: "Credit", date: "2026-03-14" },
];

const Wallet = () => {
  // 🔹 Separate States
  const [balanceSearchQuery, setBalanceSearchQuery] = useState("");
  const [transactionSearchQuery, setTransactionSearchQuery] = useState("");

  const [balancePage, setBalancePage] = useState(1);
  const [transactionPage, setTransactionPage] = useState(1);

  const [balanceLimit, setBalanceLimit] = useState(1);
  const [transactionLimit, setTransactionLimit] = useState(1);

  useEffect(() => {
    setBalancePage(1);
  }, [balanceSearchQuery, balanceLimit]);

  useEffect(() => {
    setTransactionPage(1);
  }, [transactionSearchQuery, transactionLimit]);

  // ------------------ FILTER ------------------

  const filteredBalanceData = useMemo(() => {
    return walletSummary.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(balanceSearchQuery.toLowerCase()),
    );
  }, [walletSummary, balanceSearchQuery]);

  const filteredTransactionData = useMemo(() => {
    return transactions.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(transactionSearchQuery.toLowerCase()),
    );
  }, [transactions, transactionSearchQuery]);

  // ------------------ PAGINATION ------------------

  const balancePaginatedData = filteredBalanceData.slice(
    (balancePage - 1) * balanceLimit,
    balancePage * balanceLimit,
  );

  const transactionPaginatedData = filteredTransactionData.slice(
    (transactionPage - 1) * transactionLimit,
    transactionPage * transactionLimit,
  );

  const totalBalancePages = Math.ceil(
    filteredBalanceData.length / balanceLimit,
  );

  const totalTransactionPages = Math.ceil(
    filteredTransactionData.length / transactionLimit,
  );

  // ------------------ HANDLERS ------------------

  const handleBalanceLimitChange = (e) => {
    setBalanceLimit(Number(e.target.value));
    setBalancePage(1);
  };

  const handleTransactionLimitChange = (e) => {
    setTransactionLimit(Number(e.target.value));
    setTransactionPage(1);
  };

  return (
    <div className="wallet-container">
      {/* ================= WALLET BALANCE ================= */}
      <div className="wallet-balance-container">
        <h2 className="wallet-balance-title">Wallet Balance</h2>

        {/* <div className="wallet-balance-filter-section">
          <div>
            <label>Show </label>
            <select onChange={handleBalanceLimitChange} value={balanceLimit}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count}>{count}</option>
              ))}
            </select>
            <span> entries</span>
          </div>

          <input
            type="text"
            placeholder="Search..."
            value={balanceSearchQuery}
            onChange={(e) => setBalanceSearchQuery(e.target.value)}
          />
        </div> */}

        <div className="wallet-table-wrapper">
          <table className="wallet-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              {balancePaginatedData.length > 0 ? (
                balancePaginatedData.map((item, index) => (
                  <tr key={item.id + "-" + index}>
                    <td>{item.user}</td>
                    <td>₹ {item.balance}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" style={{ textAlign: "center" }}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* {filteredBalanceData.length > balanceLimit && (
          <div className="wallet-pagination">
            <button
              onClick={() => setBalancePage(balancePage - 1)}
              disabled={balancePage === 1}
            >
              ⬅ Prev
            </button>

            <span>
              Page {balancePage} of {totalBalancePages}
            </span>

            <button
              onClick={() => setBalancePage(balancePage + 1)}
              disabled={balancePage === totalBalancePages}
            >
              Next ➡
            </button>
          </div>
        )} */}
      </div>

      {/* ================= TRANSACTION ================= */}
      <div className="wallet-transaction-container">
        <h2 className="wallet-transaction-title">Transaction History</h2>

        <div className="wallet-transaction-filter-section">
          <div>
            <label>Show </label>
            <select
              onChange={handleTransactionLimitChange}
              value={transactionLimit}
            >
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count}>{count}</option>
              ))}
            </select>
            <span> entries</span>
          </div>

          <input
            type="text"
            placeholder="Search..."
            value={transactionSearchQuery}
            onChange={(e) => setTransactionSearchQuery(e.target.value)}
          />
        </div>

        <div className="wallet-table-wrapper">
          <table className="wallet-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Amount</th>
                <th>Type</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {transactionPaginatedData.length > 0 ? (
                transactionPaginatedData.map((item, index) => (
                  <tr key={item.id + "-" + index}>
                    <td>{item.user}</td>
                    <td>₹ {item.amount}</td>
                    <td
                      className={
                        item.type === "Credit"
                          ? "wallet-credit"
                          : "wallet-debit"
                      }
                    >
                      {item.type}
                    </td>
                    <td>{item.date}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {filteredTransactionData.length > transactionLimit && (
          <div className="wallet-pagination">
            <button
              onClick={() => setTransactionPage(transactionPage - 1)}
              disabled={transactionPage === 1}
            >
              ⬅ Prev
            </button>

            <span>
              Page {transactionPage} of {totalTransactionPages}
            </span>

            <button
              onClick={() => setTransactionPage(transactionPage + 1)}
              disabled={transactionPage === totalTransactionPages}
            >
              Next ➡
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Wallet;
